const initializeMockWorker = async () => {
  // Initialize the mock worker for an improved developer experience
  if (process.env.NODE_ENV === "development") {
    const { worker } = await import("./browser");
    // await worker.start();
  }
};

export default initializeMockWorker;
